import { Component, Input, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Mission } from 'src/app/services/missions/missions.models';
import { TournamentService } from 'src/app/services/tournaments/tournament.service';
import { CommonTournament, NetworkTournament, Tournament } from 'src/app/services/tournaments/tournaments.models';

@Component({
  selector: 'app-mission-tabs',
  templateUrl: './missions-tabs.component.html',
  styleUrls: ['./missions-tabs.component.scss']
})
export class MissionTabsComponent implements OnInit {
  // tabIndex: number = 0;
  private localStorageKey: string = '';

  @Input() mission: Mission;
  // @Input() tournament: CommonTournament;
  constructor(public tournamentService: TournamentService) { }

  ngOnInit(): void {
    // this.tabIndex = this.tournamentService.getTournamentTab(this.mission.cmsId);
  }
  // public isRegularTournament(): Tournament | undefined {
  //   return !this.tournament.isNetworkTournament ? this.tournament as Tournament : undefined;
  // }
  // public isNotRegularTournament(): NetworkTournament | undefined {
  //   return this.tournament.isNetworkTournament ? this.tournament as NetworkTournament : undefined;
  // }

  // onTabChange(event: MatTabChangeEvent) {
  //   this.tournamentService.saveTournamentTab(this.mission.cmsId, event.index);
  // }
}
